import React, { useState } from 'react'
import { Form, Field } from 'redux-form'

import { Row, Col } from 'components/Layout'
import { Input } from 'components/Input/Input'
import DatePicker from 'components/Input/DatePicker'
import Button from 'components/Button'
import {
  vRequired,
  vEmail,
  vMobilePhone,
  vPasswordIdentical,
  vPassword,
} from 'components/Input/Input.validations'

import VerificationForm from '../VerificationForm'

import cn from 'classnames'
import s from './JoinAccountForm.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default props => {
  const { afterSubmit, allConfirmed } = props

  const [step, setStep] = useState('join')

  if (step === 'verify') {
    return (
      <>
        <div style={{ marginBottom: '2rem' }} className={sText.descrip2}>
          Now we need to verify your email and phone number. Please enter confirmation codes we've
          sent to you via email and SMS.
        </div>

        <VerificationForm />

        <div className={cn(sLay['layout-row'], sLay['layout-align-center'])}>
          <div className={cn(s.buttonsContainer, sLay['layout-column'])}>
            <Button color="tertiary" disabled={!allConfirmed} onClick={afterSubmit}>
              Proceed
            </Button>
          </div>
        </div>
      </>
    )
  }

  const { registerUser, handleSubmit, submitting, prev, prevText, invalid, option } = props

  const onSubmit = formData => {
    // convert birthDate to yyyy-mm-dd format
    const [day, month, year] = formData.birthDate.split('/')
    const data = {
      ...formData,
      birthDate: `${year}-${month}-${day}`,
      // inject option from query string
      // special value will disable free/disposal email check
      option,
    }

    return registerUser(data).then(() => {
      setStep('verify')
    })
  }

  const vBirthDate = value => {
    const [day, month, year] = value.split('/')

    if (!day || !month || !year || day > 31 || month > 12 || year < 1000) {
      return 'Please use dd/mm/yyyy format'
    }

    const currentYear = new Date().getFullYear()
    if (year < 1900 || year > currentYear - 10) {
      return 'Really?'
    }

    return undefined
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className={sLay['layout-column']}>
      <div className={sLay['layout-column']}>
        <Row className={cn(sLay['layout-xs-col'], sLay['layout-gt-xs-row'])}>
          <Col className={sLay['flex-gt-xs-50']}>
            <Field name="firstName" component={Input} label="First name" validate={vRequired} />
          </Col>
          <Col className={sLay['flex-gt-xs-50']}>
            <Field name="lastName" component={Input} label="Last name" validate={vRequired} />
          </Col>
        </Row>

        <Field
          name="birthDate"
          component={DatePicker}
          label="Date Of Birth"
          validate={[vRequired, vBirthDate]}
          info="<b>Important!</b> This can not be changed"
        />

        <Field
          name="email"
          type="email"
          component={Input}
          label="Email"
          validate={[vRequired, vEmail]}
          info="<b>Important!</b> You will be required to confirm this email"
        />

        <Field
          name="phone"
          type="tel"
          component={Input}
          label="Mobile Phone Number"
          validate={[vRequired, vMobilePhone]}
          info="<b>Important!</b> You will be required to confirm this number via SMS"
        />

        <Field
          name="password"
          type="password"
          component={Input}
          label="Password"
          validate={[vRequired, vPassword]}
        />

        <Field
          name="confirmPassword"
          type="password"
          component={Input}
          label="Confirm Password"
          validate={[vRequired, vPasswordIdentical, vPassword]}
        />

        <div className={s.confirm}>
          <p>
            We will always respect your privacy. See our{' '}
            <a target="_blank" rel="noopener noreferrer" href="/privacy">
              Privacy Policy
            </a>{' '}
            to find out more.
          </p>
        </div>
      </div>

      <div className={cn(sLay['layout-row'], sLay['layout-align-center'])}>
        <div className={cn(s.buttonsContainer, sLay['layout-column'])}>
          <Button
            color="tertiary"
            type="submit"
            loading={submitting}
            disabled={invalid || submitting}
          >
            Sign Up
          </Button>

          <div
            className={cn(sLay['layout-row'], sLay['layout-align-center'])}
            style={{ marginTop: '30px' }}
          >
            <Button prev onClick={prev}>
              {prevText || 'Cancel'}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccountForm/JoinAccountForm.jsx